module.exports = __webpack_public_path__ + "static/DoorDash-8282e955034a598fc89811dd980658a0.jpg";